import {
  Component, HostBinding, OnInit,
  ViewChild, ViewContainerRef,
  AfterViewInit, Injector, OnDestroy, HostListener,
} from '@angular/core';
import {Subscription} from 'rxjs';

import {ExgOverlayService} from './exg-overlay.service';
import {ExgWidgetService} from '../../exg-widget.service';


@Component({
  selector: 'exg-overlay',
  templateUrl: './exg-overlay.component.html',
  styleUrls: ['./exg-overlay.component.scss']
})
export class ExgOverlayComponent implements OnInit, AfterViewInit, OnDestroy {

  @HostBinding('class.is-open')

  private isOpen = false;
  private componentRef: any = null;

  style = {};
  private scChange: Subscription | undefined;
  private scUpdate: Subscription | undefined;
  private scInitialize: Subscription | undefined;

  @ViewChild('vc', {read: ViewContainerRef}) entry!: ViewContainerRef;
  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    event.preventDefault();
    this.onClose();
  }
  constructor(private popUpService: ExgOverlayService, private injector: Injector, private app: ExgWidgetService) {
  }

  loadComponent(name: string): void {
    this.entry.clear();
    this.componentRef = this.entry.createComponent(this.app.GetFactory(name), undefined, this.injector);
  }

  ngOnInit(): void {
    this.scChange = this.popUpService.change.subscribe((isOpen: boolean) => {

      this.isOpen = isOpen;
      if (!this.isOpen && this.componentRef) {
        this.componentRef.destroy();
        this.componentRef = null;
      }

      if (this.popUpService.forceToggleEvent) {
        this.popUpService.toggled.emit();
        this.popUpService.forceToggleEvent = false;
      }
    });
    this.scInitialize = this.popUpService.initialize.subscribe((name: string) => {
      this.loadComponent(name);
    });
    this.scUpdate = this.popUpService.update.subscribe((data: string) => {
      if (this.componentRef) {
        this.componentRef.instance.data = data;
      }
    });
  }

  ngAfterViewInit(): void {
  }


  onClose():void{
    this.style = {animation: 'zoom-out 200ms ease-out'};
    setTimeout(()=>{
      this.popUpService.action(false);
      this.style = ''
    }, 200);
  }


  ngOnDestroy(): void {
    if (this.scUpdate instanceof Subscription) {
      this.scUpdate.unsubscribe();
    }
    if (this.scChange instanceof Subscription) {
      this.scChange.unsubscribe();
    }
    if (this.scInitialize instanceof Subscription) {
      this.scInitialize.unsubscribe();
    }
  }


}
